module.exports = __webpack_public_path__ + "static/sncf-ca80f22d4e4f77c6f7f6957d398ebca4.png";